import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import OH4 from "./pages/OH4";
import IoTSensors from "./pages/IoTSensors";
import ESGSupport from "./pages/ESGSupport";
import AwaabsLaw from "./pages/AwaabsLaw";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import FresherMat from "./pages/FresherMat";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/oh4" element={<OH4 />} />
          <Route path="/iot-sensors" element={<IoTSensors />} />
          <Route path="/esg-support" element={<ESGSupport />} />
          <Route path="/awaabs-law" element={<AwaabsLaw />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/freshermat" element={<FresherMat />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
